import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class BroadcastService {

	static activeEvents: any = {};

	broadcast(eventName: string, eventData: any = null) {
		const emitter: EventEmitter<any> = BroadcastService.activeEvents[eventName] as EventEmitter<any>;
		if (emitter) {
			emitter.emit(eventData);
		}
	}

	getEmitter<T>(eventName: string): EventEmitter<T> {
		let emitter: EventEmitter<T> = BroadcastService.activeEvents[eventName] as EventEmitter<T>;
		if (!emitter) {
			emitter = BroadcastService.activeEvents[eventName] = new EventEmitter<T>();
		}
		return emitter;
	}

	setEmitter<T>(eventName: string, emitter: EventEmitter<T>): void {
		BroadcastService.activeEvents[eventName] = emitter;
	}

	dropEmitter(eventName: string) {
		delete BroadcastService.activeEvents[eventName];
	}
}
